import { createStyles } from '@mantine/emotion';

export const useStyles = createStyles((theme) => ({
  modal: {
    padding: `${theme.spacing.md} !important`
  },
  header: {
    display: 'none'
  }
}));
